import { httpsCallable } from 'firebase/functions';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkCreator } from '../../../index';
import { SUBSCRIPTION_REDUCER_NAME } from '../types';
import { ClientInvoiceData } from '../../../../models/documents';

type Payload = ClientInvoiceData;

export const updateUserInvoiceData = createAsyncThunk<void, Payload, AsyncThunkCreator<number>>(
  `${SUBSCRIPTION_REDUCER_NAME}/updateUserInvoiceData`,
  async (payload, { rejectWithValue, extra: { functions } }) => {
    try {
      await httpsCallable(functions, 'subscriptions-onCustomerDataUpdate')(payload);
    } catch (e) {
      const error = e as any;

      return rejectWithValue(error.message);
    }

    return;
  }
);
